import { render, staticRenderFns } from "./TestingModal.vue?vue&type=template&id=93bc5968&scoped=true&"
import script from "./TestingModal.vue?vue&type=script&lang=js&"
export * from "./TestingModal.vue?vue&type=script&lang=js&"
import style0 from "./TestingModal.vue?vue&type=style&index=0&id=93bc5968&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bc5968",
  null
  
)

export default component.exports